export default {
  sessionStatus: {
    PENDING: "En curso",
    CONFIRMED: "Confirmada",
    EXPIRED: "Caducada",
    CANCELLED: "Cancelada",
  },
  messageStatus: {
    DELIVERED: "Entregado",
    BLOCKED: "Bloqueado",
  },
  sender: {
    CUSTOMER: "Cliente",
    SELLER: "Vendedor",
    ADMIN: "Staff",
    SYSTEM: "Sistema",
  },
  channel: {
    WHATSAPP: "WhatsApp",
    SMS: "SMS",
    EMAIL: "Correo electrónico",
  },
  messageInput: {
    send: "Enviar",
  },
  bubble: {
    agreementDetected: "Acuerdo detectado",
  },
  audit: {
    blockReason: "Motivo del bloqueo",
    gptAnalysis: "Metadatos de moderación",
    sent: "Enviada",
    notSent: "No enviada",
    internalNote: "Interno (no enviado al cliente)",
    viaChannel: "vía {{channel}}",
  },
  listItem: {
    agreementReached: "✅ Acuerdo alcanzado",
  },
  filters: {
    allSellers: "Todos los vendedores",
    panelTitle: "Filtros",
    clearAll: "Borrar todo",
    status: "Estado",
    channel: "Canal",
    customerName: "Nombre del cliente",
    customerNamePlaceholder: "Buscar por nombre del cliente…",
    dateRange: "Rango de fechas",
    from: "Desde",
    to: "Hasta",
    seller: "Vendedor",
    clear: "Borrar",
    search: "Buscar",
  },
} as const;
